import {
  EventDataType,
  ResolvedAdSettings,
} from '@sportworld/js-sdk/src/types/servicesTypes/configTypes'

import {
  EndActions,
  TileType,
  tileTypes,
} from '@/types/servicesTypes/configTypes'
import { TizenChannel } from '@/types/utilsTypes'

export const homePageRawData = [
  { name: 'Promo', w: 3, h: 2 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },

  { name: 'box 1x3 tall', w: 1, h: 3 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 2 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 2 },

  { name: 'box 3x1 wide', w: 3, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },

  { name: 'box 2x1 wide', w: 2, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },

  { name: 'box 2x1 wide', w: 2, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 2x1 wide', w: 2, h: 1 },

  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x2 tall', w: 1, h: 2 },

  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 2x1 wide', w: 2, h: 1 },

  { name: 'box 1x1', w: 1, h: 1 },
  { name: 'box 1x1', w: 1, h: 1 },

  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 2 },
  { name: 'box', w: 1, h: 2 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 2 },
  { name: 'box', w: 1, h: 2 },
  { name: 'box', w: 1, h: 2 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 3 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 3 },
  { name: 'box', w: 3, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 3, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 3, h: 1 },
  { name: 'box', w: 2, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 1, h: 1 },
  { name: 'box', w: 2, h: 1 },
]

export const homePage = [
  [
    [{ name: 'Promo', w: 2, h: 1 }],
    [{ name: 'box', w: 2, h: 1 }],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 1, h: 1 },
    ],
  ],
  [[{ name: 'Promo', w: 2, h: 2 }]],
  [[{ name: 'box', w: 1, h: 2 }], [{ name: 'box', w: 1, h: 1 }]],
  [[{ name: 'box', w: 1, h: 1 }], [{ name: 'box', w: 1, h: 2 }]],
  [[{ name: 'box', w: 1, h: 2 }]],
  [[{ name: 'box', w: 1, h: 2 }], [{ name: 'box', w: 1, h: 1 }]],
  [[{ name: 'box', w: 1, h: 3 }]],
  [[{ name: 'box', w: 2, h: 1 }], [{ name: 'box', w: 2, h: 1 }]],
  [[{ name: 'box', w: 1, h: 3 }]],
  [
    [{ name: 'box', w: 3, h: 1 }],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 2, h: 1 },
    ],
    [{ name: 'box', w: 2, h: 1 }],
  ],
  [
    [{ name: 'box', w: 2, h: 1 }],
    [{ name: 'box', w: 2, h: 1 }],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 1, h: 1 },
    ],
  ],
  [
    [{ name: 'box', w: 2, h: 1 }],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 1, h: 1 },
    ],
    [{ name: 'box', w: 2, h: 1 }],
  ],
  [
    [{ name: 'box', w: 3, h: 1 }],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 2, h: 1 },
    ],
    [
      { name: 'box', w: 2, h: 1 },
      { name: 'box', w: 1, h: 1 },
    ],
  ],
  [
    [{ name: 'box', w: 3, h: 1 }],
    [
      { name: 'box', w: 2, h: 1 },
      { name: 'box', w: 1, h: 1 },
    ],
    [
      { name: 'box', w: 1, h: 1 },
      { name: 'box', w: 2, h: 1 },
    ],
  ],
]

export const actionDataVodMock =
  '{"id":"sw$elf-final","title":"EUROPEAN LEAGUE OF FOOTBALL: CHAMPIONSHIP GAME - VIENNA VIKINGS VS. HAMBURG SEA DEVILS","image":{"id":null,"sources":[{"format":"Jpeg","width":1920,"height":1080,"url":"https://sportworld-public-assets.cdn.b1smarttv.com/assets/elf/ELF_Final.png","darkTheme":false}]},"content":{"type":"Ad","event":{"id":"sw$2022-elf-final","categoryId":"americanFootball","name":"EUROPEAN LEAGUE OF FOOTBALL: CHAMPIONSHIP GAME - VIENNA VIKINGS VS. HAMBURG SEA DEVILS","description":{"glance":null,"competition":"American Football","short":null,"long":"American Football pur! Am Sonntag, 25.09.2022, treffen um 14:45 Uhr (Kick-Off) die Vienna Vikings und die Hamburg Sea Devils zum finalen Showdown im Championship Game der European League of Football aufeinander. Erlebe das Event mit unserer innovativen Multi View-Technologie, bei der du das Finale parallel am Smartphone aus 9 unterschiedlichen Kameraperspektiven erleben kannst. Lade dir dazu die Sportworld-App auf dein Smartphone runter.","extended":null,"transcript":null,"closedcaptions":null},"image":{"id":null,"sources":[{"format":"Jpeg","width":1920,"height":1080,"url":"https://sportworld-public-assets.cdn.b1smarttv.com/assets/elf/ELF_Final.png","darkTheme":false}]},"channelId":"sw$elf","content":{"type":"Channel","video":{"id":"sw$Video-ELF","sources":[{"format":"Hls","url":"https://b1smarttv-nativewaves.amagi.tv/objects/stream$0492da368ff041508b405e5f72312af2$1627865417252e861af94260a74a7/formats/hls/data/master-parts.m3u8"}]},"deepLink":null},"startTime":1664109000,"endTime":1664125200,"nativewaves":{"programId":"c5b0e6eedcfb4c7bbf45630992bdfe3b","smdsDirectSyncId":null},"accessRightIds":[],"preview":null,"live":false},"deepLink":null,"video":{"id":"sw$Video-ELF","sources":[{"format":"Hls","url":"https://b1smarttv-nativewaves.amagi.tv/objects/stream$0492da368ff041508b405e5f72312af2$1627865417252e861af94260a74a7/formats/hls/data/master-parts.m3u8"}]}},"enableShading":true,"accessRightIds":[],"preview":null}'

export const largeArticleMock = `
From Wikipedia, the free encyclopedia
Not to be confused with Disinformation or Misinformation effect.
Misinformation is incorrect or misleading information.[1][2] It differs from disinformation, which is deliberately deceptive and propagated information.[3][4][5] Early definitions of misinformation focused on statements that were patently false, incorrect, or not factual.[6] Therefore, a narrow definition of misinformation refers to the information’s quality, whether inaccurate, incomplete, or false.[7] However, recent studies define misinformation per deception rather than informational accuracy[8] because misinformation can include falsehoods, selective truths, and half-truths.[9]

Research on how to correct misinformation have focused on fact-checking.[10] However, one can fact-check news, but not beliefs,[11] and studies show that fact-checking can backfire.[12] Others studied what makes people susceptible to misinformation. People may be more prone to believe misinformation because they are emotionally connected to what they are listening to or are reading. The role of social media has made information readily available to society at anytime, and it connects vast groups of people along with their information at one time.[13] Advances in technology has impacted the way people communicate information and the way misinformation is spread.[10] Misinformation has impacts on societies' ability to receive information which then influences our communities, politics, and medical field.[13]

The term came into wide coinage during the late 2010s and early 2020s, when it was used to describe policies to combat misinformation. The term as been used to suppress legitimate and true speech, and control political discourse.[14]

History
Early examples include the insults and smears spread among political rivals in Imperial and Renaissance Italy in the form of pasquinades.[15] These are anonymous and witty verses named for the Pasquino piazza and talking statues in Rome. In pre-revolutionary France, "canards", or printed broadsides, sometimes included an engraving to convince readers to take them seriously.

During the summer of 1588, continental Europe anxiously awaited news as the Spanish Armada sailed to fight the English. The Spanish postmaster and Spanish agents in Rome promoted reports of Spanish victory in hopes of convincing Pope Sixtus V to release his promised of one million ducats upon landing of troops. In France, the Spanish and English ambassadors promoted contradictory narratives in the press, and a Spanish victory was incorrectly celebrated in Paris, Prague, and Venice. It was not until late August that reliable reports of the Spanish defeat arrived in major cities and were widely believed; the remains of the fleet returned home in the autumn.[16]


A lithograph from the first large scale spread of disinformation in America, the Great Moon Hoax
The first recorded large-scale disinformation campaign was the Great Moon Hoax, published in 1835 in the New York The Sun, in which a series of articles claimed to describe life on the Moon, "complete with illustrations of humanoid bat-creatures and bearded blue unicorns".[17] The challenges of mass-producing news on a short deadline can lead to factual errors and mistakes. An example of such is the Chicago Tribune's infamous 1948 headline "Dewey Defeats Truman".

Social media platforms allow for easy spread of misinformation. Post election surveys in 2016 suggest that many individuals who intake false information on social media believe them to be factual.[18] The specific reasons why misinformation spreads through social media so easily remain unknown. A 2018 study of Twitter determined that, compared to accurate information, false information spread significantly faster, further, deeper, and more broadly. Similarly, a research study of Facebook found that misinformation was more likely to be clicked on than factual information.


Harry S. Truman displaying the inaccurate Chicago Tribune headline, an example of misinformation.
Moreover, the advent of the Internet has changed traditional ways that misinformation spreads.[19] During the 2016 United States presidential election, it was seen that content from websites deemed 'untrustworthy' were reaching up to 40% of Americans, despite misinformation making up only 6% of overall news media.[20] Misinformation has been spread during many health crises.[21] For example, misinformation about alternative treatments were spread during Ebola outbreak in  2014–2016.[22][23] Also, later during the COVID-19 pandemic, both intentional and unintentional misinformation combined with a general lack of literacy regarding health science and medicine was proliferated, creating further misinformation.[24] What makes those susceptible to misinformation is still debated, however.[25]
`

export const tizenChannelListMock: TizenChannel[] = [
  {
    _serviceId: '2626725582183860222',
    channelName: 'TVP1 HD',
    lcn: 1,
    major: 1,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 1,
    ptc: 9120,
    scrambled: false,
    serviceName: 'TVP1 HD',
    serviceType: 'DVB_SERVICE_TYPE_UNKNOWN',
    sourceID: 0,
    transportStreamID: 3,
  },
  {
    _serviceId: '2626725582192249854',
    channelName: 'TVP2 HD',
    lcn: 2,
    major: 2,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 2,
    ptc: 9120,
    scrambled: false,
    serviceName: 'TVP2 HD',
    serviceType: 'DVB_SERVICE_TYPE_UNKNOWN',
    sourceID: 0,
    transportStreamID: 3,
  },
  {
    _serviceId: '2626725582360023038',
    channelName: 'TVP3 Wroclaw',
    lcn: 3,
    major: 3,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 22,
    ptc: 9120,
    scrambled: false,
    serviceName: 'TVP3 Wroclaw',
    serviceType: 'DVB_SERVICE_TYPE_UNKNOWN',
    sourceID: 0,
    transportStreamID: 3,
  },
  {
    _serviceId: '2637984581629799422',
    channelName: 'POLSAT HD',
    lcn: 65535,
    major: 4,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 46,
    ptc: 9440,
    scrambled: false,
    serviceName: 'POLSAT HD',
    serviceType: 'DVB_SERVICE_TYPE_TELEVISION',
    sourceID: 0,
    transportStreamID: 45138,
  },
  {
    _serviceId: '2400490070474854398',
    channelName: 'EmiTV',
    lcn: 99,
    major: 99,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 99,
    ptc: 2690,
    scrambled: false,
    serviceName: 'EmiTV',
    serviceType: 'DVB_SERVICE_TYPE_UNKNOWN',
    sourceID: 0,
    transportStreamID: 28673,
  },
  {
    _serviceId: '2722427075171563518',
    channelName: 'Wydarzenia 24 HD HEVC',
    lcn: 65535,
    major: 109,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 109,
    ptc: 11840,
    scrambled: false,
    serviceName: 'Wydarzenia 24 HD HEVC',
    serviceType: 'DVB_SERVICE_TYPE_TELEVISION',
    sourceID: 0,
    transportStreamID: 61441,
  },
  {
    _serviceId: '2722427075171563510',
    channelName: 'ARD',
    lcn: 65535,
    major: 109,
    minor: 65534,
    originalNetworkID: 8808,
    programNumber: 109,
    ptc: 11840,
    scrambled: false,
    serviceName: 'ARD MOCK',
    serviceType: 'DVB_SERVICE_TYPE_TELEVISION',
    sourceID: 0,
    transportStreamID: 61441,
  },
] as TizenChannel[]

export const pageMock = {
  id: 'sw$b249568a8f6e4f3a8',
  categoryId: 'americanFootball',
  pageType: 'Tabs',
  name: 'European League of Football',
  title: 'European League of Football',
  icon: {
    sources: [
      {
        format: 'Jpeg',
        width: 200,
        height: 67,
        url: 'https://sportworld-public-assets.cdn.b1smarttv.com/logos/logo_efl.png',
        darkTheme: true,
      },
    ],
  },
  logo: {
    sources: [
      {
        format: 'Jpeg',
        width: 200,
        height: 67,
        url: 'https://sportworld-public-assets.cdn.b1smarttv.com/logos/logo_efl.png',
        darkTheme: true,
      },
    ],
  },
  backgroundImage: {
    sources: [
      {
        format: 'Png',
        width: 1920,
        height: 1080,
        url: 'https://sportworld-public-assets.cdn.b1smarttv.com/03_Tab_Templates/02_ELF/00_Background/01_Tab_Template_Highlights_ELF_Background_CTV.png',
        darkTheme: true,
      },
    ],
  },
  lines: [],
  tabs: [
    {
      title: 'Home',
      type: 'SectionGrid',
      sectionGrid: {
        sections: [
          {
            gridContextId: 'sw$ttElfLive',
            invisible: false,
            title: 'European League of Football Live',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfChampionshipGame',
            invisible: false,
            title: 'Championship Game 2022',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfStats2022',
            invisible: false,
            title: 'Stats 2022',
            minFillRate: 0,
            layout: 'Horizontal',
          },
        ],
      },
      lines: [],
    },
    {
      title: 'Teams',
      type: 'SectionGrid',
      sectionGrid: {
        sections: [
          {
            gridContextId: 'sw$ttElfTeamsEastern',
            invisible: false,
            title: 'Eastern Conference',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfTeamsCentral',
            invisible: false,
            title: 'Central Conference',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfTeamsWestern',
            invisible: false,
            title: 'Western Conference',
            minFillRate: 0,
            layout: 'Horizontal',
          },
        ],
      },
      lines: [],
    },
    {
      title: 'Stats',
      type: 'SectionGrid',
      sectionGrid: {
        sections: [
          {
            gridContextId: 'sw$ttElfStatsOffense',
            invisible: false,
            title: 'Offense Stats',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfStatsDefense',
            invisible: false,
            title: 'Defense and Kicking Stats',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfStatsTeams',
            invisible: false,
            title: 'Team & League Stats',
            minFillRate: 0,
            layout: 'Horizontal',
          },
        ],
      },
      lines: [],
    },
    {
      title: 'Shop',
      type: 'SectionGrid',
      sectionGrid: {
        sections: [
          {
            gridContextId: 'sw$ttElfShopSpecials',
            invisible: false,
            title: 'ELF Specials',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfShopFanwear',
            invisible: false,
            title: 'Official Fanware',
            minFillRate: 0,
            layout: 'Horizontal',
          },
          {
            gridContextId: 'sw$ttElfShopNFT',
            invisible: false,
            title: 'NFT Club',
            minFillRate: 0,
            layout: 'Horizontal',
          },
        ],
      },
      lines: [],
    },
    {
      title: 'Events',
      type: 'Lines',
      sectionGrid: {
        sections: [],
      },
      lines: [
        {
          lineContextId: 'sw$americanFootballUpcoming',
          name: 'upcoming',
          lineType: 'ClassicTiles',
          allowHideIfEmpty: false,
        },
      ],
    },
  ],
  palette: {
    colors: {
      secondary: '#1f1b26',
      gradient: {},
    },
  },
}

export const homePageTabsData_deprecated = [
  {
    name: 'Home',
    stage: [
      {
        title: 'Highlights der Euro 2024',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et hic nobis sapiente, corrupti odio omnis nostrum similique id cumque repellendus! Nulla, odit?',
        backgroundMediaType: 'image',
        backgroundMedia: 'https://picsum.photos/960/540',
      },
      {
        title: 'Olympics',
        description:
          'The Olympic Games, officially known as the Olympic Movement, is a worldwide sporting event featuring a variety of sports and games. The Games are held every four years, with the exception of the 1916 Games which were cancelled due to World War I. The Olympic Games are one of the largest multi-sport events in the world, with over 200 sports represented at the Summer Games and 14 sports represented at the Winter Games.',
        backgroundMediaType: 'image',
        backgroundMedia: 'https://picsum.photos/960/640',
      },
      {
        title: 'Bundesliga 2024',
        description:
          'The Bundesliga, commonly known as the German Football League, is the top-level football league in Germany. It is governed by the German Football Association (DVFB) and is the second-largest football league in Europe, after the English Premier League. The Bundesliga is contested by 16 teams, with the champion earning promotion to the 2. Bundesliga. The league has been a major force in German football for decades, producing some of the country’s most successful and successful-financing clubs.',

        backgroundMedia:
          'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
        backgroundMediaType: 'mp4',
      },
    ],
  },
  {
    name: 'Watch',
    stage: [
      {
        title: 'Bundesliga 2025',
        description:
          'The Bundesliga, commonly known as the German Football League, is the top-level football league in Germany. It is governed by the German Football Association (DVFB) and is the second-largest football league in Europe, after the English Premier League. The Bundesliga is contested by 16 teams, with the champion earning promotion to the 2. Bundesliga. The league has been a major force in German football for decades, producing some of the country’s most successful and successful-financing clubs.',

        backgroundMedia:
          'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
        backgroundMediaType: 'mp4',
      },
      {
        title: 'WPT',
        description: 'WPT Cash Game $200/$400 No Limit Holdem 2022 - Part 1',
        backgroundMedia:
          'https://amg00218-amg00218c1-sportworld-europe-3409.playouts.now.amagi.tv/playlist/amg00218-wptenterprisesfast-worldpokertour-sportworldeurope/cb7d3e4f7b706fdf99cb386cd2f013a9d10e3689573ad1303da85e9175c21d5382bbf5cbe71ebd3b0dbd5aa33e40340d0136d41cc07c11dfa32bfb086a384837c293a20287dd4755a2a55e793acc190e39ee0f15bf24564d8ea05a29952db97c3216ea2267427ddbed5cb3774cc4851a930451efd0a17d29210304ca4d2ab0f305fce6f13b109a2ff8ee425794295be7922198824df9d9cb5d9e469877ef159880e4d8d213d6d2c266ae4ab761080d6f2cc8857fdec80de28cd73c3cc92170471c0dbef3caaf1444ec2f424ce8c0c5be68fa61a2e34fb27038a9148f40963c8e31db63c5e85bd2c6d1b670640988e578440a85bfcbe09f3237ad7489c183bc2226ec9c727143dd74c8275953fa94f931b4ef34b5930ea0ee03775bc49f51e9fed8e2bfeafb20ff21c3c386f7572f406c10429548b28a62c93dd87cf2bb79445b484abf9f27a8ecb36c155263a7a37beb3e3ee3a6e1e9de1e2bf5620e54ec6cdc296a06a13a6368a53eec8a2c639b320f816f6a913b20924e8ee846bbafcff11628ef918851ef60fda11ddde40ead20284f4fb7f72e4a42027f81fd6b0c226dd753aad0c5ec38010fe1f2978daa3f3f0329056d0f84ecf475959ab24a777790095b0a191107863bc57dd0124c3f3bdb12a1c0631eb7231101c7841a627749ccbadbe38ed5b828df15e1eacd150e187c5c90165f5304b6b58249ed3939121037b22a546f9c247f7dc7b09391f3ea7bdda374b831741560dc82712b6d034a4d24a9a002a536522d4dc9fab03efcc3cf74758a30a20f14eca1b60eddd8f10bcb92f2d0313c7285dc37c0094d8d778668e0d6017284f4ced8426a68bb9029a7589db6cfe761f709b85d0c6eef378c9df1a0d7716c37f020261e064f1e735e776359f68a952c2d7aefb529f252f5e30ee96b5a273a4b9eaf015dc6c7445ca4752f309af19eb4fa834331da7ef870fe65018d5e1961b79c6da4d2fca2afc7277f28ed9b8700fbad818ac996ed237d006379dbf75a4764d129fec356b7e34d3cdc888de4c867d823b260f5d5f87fb14ecfa1d8219dd0a58c9c2647610b02c3968dbc7ebe9d1a55b77ea9280c088c86e18e08c8dbba066ae31dadc5285dee063c3aedaee80fdc24a8ec5b78bf9f08b9b4f7be72359941eef52efb2be167c879817d9304a854/28/1280x720_2964940/index.m3u8',
        backgroundMediaType: 'hls',
      },
      {
        title: 'Insight Zone',
        description: 'Insight Zone: MLS',
        backgroundMedia:
          'https://amg00622-amg00622c16-sportworld-europe-3130.playouts.now.amagi.tv/playlist/amg00622-sportworld-mlsen-sportworldeurope/cb7d3e4f7b706fdf99cb386cd2f013a9d10e3689573ad1303da85e9175c21d5382bbf5cbe71ebd3b0dbd57bb225f2f4c2c309e479a7611ba8130f10d682d08718498a263bae4636bd6c56b4c21a306672f9b661ec0410a68dce75a5ccb6dfc392403f8056b61378f9600e96957c6871488793993d6a5054401464fc30406b0b029f6acba025cc80af4f35f11ca715ae39c42d9b07aabe3850dcf01df69f4179a8cf38dc104d6d7c36aa952ba6d440d777ccccd28c2cc5bfb83c8686fd129291f1a0db2a6c5fd1d6f851d36369ef6cfab7cef16bce24fe852128b2cb96ca11daf31db63c2e64baebfbead2a2b5fb7cb586222b2bfcbe09f3237ad7489c183bc2226ed9c7e6d54f67dca2b3d3993e4b972eea744af980ddfe3037e2dd29d37cbf7fc8bfba49d59c66a85d4e4972f56596c160e8210b68c20df2cdf6daf8011704f4045bf8e41d2c8da513d2d47898d5b8e7e71dbd288f1b8645ee341390bbf3aac31606fc3247c7d974193f00e49b90a2ba61002d67d6fbf2891b93ce598c8f10929b0e1d250f31dc1df26dae216b97e66164da0f72053405e33c3ef6b1e2577c444f4c3d9af74060da3e3dbb1d45a2202375a531c9beeee739a9ac9261359c55a35746619158310d3268c52195177994d83fd5125d5537b558ccf3e4d4a5398c9bc84f5baa02e866fdcdde92e20295567e7456f456adab2ff36975545716e1d931a7453b2154e47eecfa38ffa8460daee07c059324e2baf9a1651196d7176049f9c6da52488eb1eb696845e9dfc8013579128b54f038edfce78efe293cb4b55e3c03b1e6387c118c67c23d412da3ffab11ab9e10f77765e495db0e53e966d9cefb6e608bf01887d331498100b22b3c3b71c34d7bd0855030659167156045d66daffe014ccff71de5d8078f3f95ab9472e5375278cc1685af74243bd54f1004a85d9d5f6f5cd27799f4ebe18ec7511a9470861d6cd2af982a5c9e4ed776113dca4e66dbca486959696e7296402603c9a8e0a1b27986ec3a126d3995048d9d2cbc9f340a24db9758f8dac2bea7cf485ec47eeb18deef772205b587cf5d5b8af478cf25913fb33f0651935b0c6a4f86cf0dffc207de956efcc4758ab2c6d54c6a5b450867bf8d20f6ad4866f58c77d7d94b3a8684f9e56c75a5277929cd33d23ae236e7ec0284091bc5befdc68a5b81d24d869aad30fee91/123/1280x720_3990800/index.m3u8',
        backgroundMediaType: 'hls',
      },
    ],
  },
  { name: 'Discover' },
]

export const TileTypeChannelMock: TileType = {
  id: 'id-channel-link-mock',
  title: 'Type: Channel Premium Mock (sw$sportdigital)',
  type: tileTypes.CHANNEL,
  image: {
    sources: [
      {
        format: 'Jpeg',
        width: 1920,
        height: 1080,
        url: 'https://sportworld-public-assets.cdn.b1smarttv.com/02_Sportword_Specials/02_Specials_Menue/Specials_Pos1_2x2.png',
        darkTheme: true,
      },
    ],
  },
  size: { width: 2, height: 2, minHeight: 2, minWidth: 2 },
  position: { index: -1, x: 0, y: 0, horizontal: false },
  shade: true,
  data: {
    channel: {
      id: 'sw$sportdigital',
      name: 'Sportdigital FUSSBALL',
      public: false,
      watchable: true,
      image: {
        sources: [
          {
            format: 'Jpeg',
            width: 210,
            height: 62,
            url: 'https://sportworld-public-assets.cdn.dev.b1smarttv.com/logos/light/logo_sdf_white.png',
            darkTheme: false,
          },
          {
            format: 'Png',
            width: -1,
            height: -1,
            url: 'https://tvprofil.net/cdn/1920x1080/11/img/covers/img2240867-logo-white-Sportdigital_Fussball_DE_logo_v2.png',
            darkTheme: false,
          },
        ],
      },
      premiumLockedscreenImage: {
        sources: [
          {
            format: 'Png',
            width: 1920,
            height: 1080,
            url: 'https://sportworld-public-assets.cdn.b1smarttv.com/assets/screen/channel_lock_screen.png',
            darkTheme: false,
          },
        ],
      },
      video: {
        sources: [
          {
            format: 'Hls',
            url: 'https://b1smarttv-nativewaves-2.amagi.tv/streams/sw02/sessions/$latest/formats/hls/data/master.m3u8',
          },
        ],
      },
      freeVideo: {
        sources: [
          {
            format: 'Mp4',
            url: 'https://sportworld-public-assets.cdn.dev.b1smarttv.com/ads/tipico_20220105/Tipico_Sportworld_v2.mp4',
          },
        ],
        onEnded: EndActions.LOOP,
      },
      knownNames: ['Sportdigital', 'Sportdigital Fußball'],
      accessRightIds: ['samsungsportpaket'],
    },
  },
}

export const channelEventMock = {
  userRights: { canAccess: true },
  id: 'tvprofil$100846262982829',
  categoryId: 'soccer',
  channelId: 'sw$insightzone-soccer-bundesliga-de',
  name: 'Channel Event Mock Name',
  startTime: Date.now() / 1000 - 20,
  endTime: Date.now() / 1000 + 20,
  description: {
    long: 'Live ist nur einmal.\nSpieltag 10: Mit innovativen Live-Statistiken zu allen Spielen in Echtzeit verpasst du keinen wichtigen Moment auf dem Platz.',
    extended:
      'Live ist nur einmal.\nSpieltag 10: Mit innovativen Live-Statistiken zu allen Spielen in Echtzeit verpasst du keinen wichtigen Moment auf dem Platz.',
    short:
      'Live ist nur einmal.\nSpieltag 10: Mit innovativen Live-Statistiken zu allen Spielen in Echtzeit verpasst du keinen wichtigen Moment auf dem Platz.',
  },
  image: {
    sources: [
      {
        format: 'Jpeg',
        width: 1280,
        height: 720,
        url: 'https://tvprofil.net/cdn/1280x720/9/img/covers/img2271564-m326676-sport_event.jpg',
        darkTheme: false,
      },
    ],
  },
  live: true,
  type: 'Channel',
  nativewaves: {
    enableSync: false,
  },
  shareable: true,
  video: {
    sources: [
      {
        format: 'Hls',
        url: 'https://cdn-uw2-prod.tsv2.amagi.tv/linear/amg00622-b1smarttvgmbh-insightzonebundesligadach-ono/playlist.m3u8?app_bundle=REPLACE_ME&app_name=sportworld&app_store_url=REPLACE_ME&genre=soccer&ic=IAB17&gdpr=REPLACE_ME&gdpr_consent=REPLACE_ME&url=REPLACE_ME&us_privacy=REPLACE_ME&lmt=REPLACE_ME&dnt=REPLACE_ME&cb=REPLACE_ME&ap=REPLACE_ME&mute=REPLACE_ME&encoded_url=REPLACE_ME',
      },
    ],
  },
  deepLink: {
    ios: {
      url: 'insightzone-soccer-bundesliga-de',
    },
    android: {
      url: 'insightzone-soccer-bundesliga-de',
    },
  },
} as EventDataType

export const channelEventMock1 = {
  ...channelEventMock,
  name: 'Mock event 1',
  startTime: Date.now() / 1000 + 10,
  endTime: Date.now() / 1000 + 20,
} as EventDataType

export const channelEventMock2 = {
  ...channelEventMock,
  name: 'Mock event 2',
  startTime: Date.now() / 1000 + 20,
  endTime: Date.now() / 1000 + 30,
} as EventDataType

export const channelEventMocks = [channelEventMock1, channelEventMock2]

export const debugAdSettings: ResolvedAdSettings = {
  ssaiUrlParameters:
    'w=1920&h=1080&cb=REPLACE_ME&ip=REPLACE_ME&ua=REPLACE_ME&lat=REPLACE_ME&lon=REPLACE_ME&dnt=REPLACE_ME&ic=REPLACE_ME&dur=REPLACE_ME&ap=REPLACE_ME&pod_max_dur=REPLACE_ME&pod_ad_slots=REPLACE_ME&app_bundle=Sportworld&app_name=Sportworld&app_store_url=Sportworld&content_id=REPLACE_ME&content_title=REPLACE_ME&content_genre=REPLACE_ME&content_livestream=REPLACE_ME&content_categories=REPLACE_ME&channel_name=REPLACE_ME&content_custom_1_param=REPLACE_ME&content_custom_2_param=amagi&language=REPLACE_ME&network_name=Sportworld&did=REPLACE_ME&device_make=REPLACE_ME&device_model=REPLACE_ME&brand_name=REPLACE_ME&country=REPLACE_ME&ifa_type=REPLACE_ME&gdpr_consent=REPLACE_ME&gdpr=REPLACE_ME&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=REPLACE_ME',
  csaiSettings: {
    preRollAdUrl:
      'https://tv.springserve.com/rt/91980?w=1920&h=1080&cb=REPLACE_ME&ip=REPLACE_ME&ua=REPLACE_ME&lat=REPLACE_ME&lon=REPLACE_ME&dnt=REPLACE_ME&ic=REPLACE_ME&dur=REPLACE_ME&ap=REPLACE_ME&pod_max_dur=60&pod_ad_slots=0-20,0-20,0-20&app_bundle=Sportworld&app_name=Sportworld&app_store_url=Sportworld&content_id=sw%24eleven-sports-4-pl&content_title=Eleven%20Sports%204%20PL&content_genre=REPLACE_ME&content_livestream=1&content_categories=REPLACE_ME&channel_name=Eleven%20Sports%204%20PL&content_custom_1_param=pre-roll&content_custom_2_param=b1smarttv&language=de-DE&network_name=Sportworld&did=REPLACE_ME&device_make=REPLACE_ME&device_model=REPLACE_ME&brand_name=REPLACE_ME&country=REPLACE_ME&ifa_type=REPLACE_ME&gdpr_consent=REPLACE_ME&gdpr=REPLACE_ME&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=REPLACE_ME',
    midRolls: [
      {
        adUrl:
          'https://tv.springserve.com/rt/91980?w=1920&h=1080&cb=REPLACE_ME&ip=REPLACE_ME&ua=REPLACE_ME&lat=REPLACE_ME&lon=REPLACE_ME&dnt=REPLACE_ME&ic=REPLACE_ME&dur=REPLACE_ME&ap=REPLACE_ME&pod_max_dur=60&pod_ad_slots=0-20,0-20,0-20&app_bundle=Sportworld&app_name=Sportworld&app_store_url=Sportworld&content_id=sw%24eleven-sports-4-pl&content_title=Eleven%20Sports%204%20PL&content_genre=REPLACE_ME&content_livestream=1&content_categories=REPLACE_ME&channel_name=Eleven%20Sports%204%20PL&content_custom_1_param=pre-roll&content_custom_2_param=b1smarttv&language=de-DE&network_name=Sportworld&did=REPLACE_ME&device_make=REPLACE_ME&device_model=REPLACE_ME&brand_name=REPLACE_ME&country=REPLACE_ME&ifa_type=REPLACE_ME&gdpr_consent=REPLACE_ME&gdpr=REPLACE_ME&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=REPLACE_ME',
        contentPosition: 30,
      },
      {
        adUrl:
          'https://tv.springserve.com/rt/91980?w=1920&h=1080&cb=REPLACE_ME&ip=REPLACE_ME&ua=REPLACE_ME&lat=REPLACE_ME&lon=REPLACE_ME&dnt=REPLACE_ME&ic=REPLACE_ME&dur=REPLACE_ME&ap=REPLACE_ME&pod_max_dur=60&pod_ad_slots=0-20,0-20,0-20&app_bundle=Sportworld&app_name=Sportworld&app_store_url=Sportworld&content_id=sw%24eleven-sports-4-pl&content_title=Eleven%20Sports%204%20PL&content_genre=REPLACE_ME&content_livestream=1&content_categories=REPLACE_ME&channel_name=Eleven%20Sports%204%20PL&content_custom_1_param=pre-roll&content_custom_2_param=b1smarttv&language=de-DE&network_name=Sportworld&did=REPLACE_ME&device_make=REPLACE_ME&device_model=REPLACE_ME&brand_name=REPLACE_ME&country=REPLACE_ME&ifa_type=REPLACE_ME&gdpr_consent=REPLACE_ME&gdpr=REPLACE_ME&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=REPLACE_ME',
        contentPosition: 50,
      },
    ],
    postRollAdUrl:
      'https://tv.springserve.com/rt/91980?w=1920&h=1080&cb=REPLACE_ME&ip=REPLACE_ME&ua=REPLACE_ME&lat=REPLACE_ME&lon=REPLACE_ME&dnt=REPLACE_ME&ic=REPLACE_ME&dur=REPLACE_ME&ap=REPLACE_ME&pod_max_dur=60&pod_ad_slots=0-20,0-20,0-20&app_bundle=Sportworld&app_name=Sportworld&app_store_url=Sportworld&content_id=sw%24eleven-sports-4-pl&content_title=Eleven%20Sports%204%20PL&content_genre=REPLACE_ME&content_livestream=1&content_categories=REPLACE_ME&channel_name=Eleven%20Sports%204%20PL&content_custom_1_param=pre-roll&content_custom_2_param=b1smarttv&language=de-DE&network_name=Sportworld&did=REPLACE_ME&device_make=REPLACE_ME&device_model=REPLACE_ME&brand_name=REPLACE_ME&country=REPLACE_ME&ifa_type=REPLACE_ME&gdpr_consent=REPLACE_ME&gdpr=REPLACE_ME&us_privacy=REPLACE_ME&coppa=REPLACE_ME&lmt=REPLACE_ME',
  },
}
